<template>
	<div>
		<b-row>
			<b-col lg="12" class="mt-lg-0 mt-3 mb-3">
				<div class="rounded bg-light-alt py-2 px-3">
					<h4 class="mb-0">{{ this.$t('payments.salesPrices') }}</h4>
				</div>
			</b-col>
		</b-row>

		<b-row>
			<b-col class="table-responsive">
				<b-table striped hover :items="itemsPrices" :fields="fieldsPrices">
					<template #cell(paymentStatus)="row">
						{{$root.getItemFromAuxVarOpts("transportServicePaymentStatusOpts", row.item.paymentStatus).text }}
					</template>
				</b-table>
			</b-col>
		</b-row>

		<b-row class="d-flex justify-content-end">
			<b-col class="col-lg-6 col-md-8">
				<b-card
					header-bg-variant="info"
					bg-variant="light"
					header-text-variant="white"
					border-variant="info"
					:header="this.$t('payments.bookingPrice')"
					class="text-center">
					<b-card-text>
						<b-table striped hover :items="totalsBooking" small>
							<template #cell(total)="row">
								{{ formatLblPrice(row.item.total, row.item.currency) }}
							</template>
							<template #cell(subtotal)="row">
								{{ formatLblPrice(row.item.subtotal, row.item.currency) }}
							</template>
						</b-table>
					</b-card-text>
				</b-card>
			</b-col>
		</b-row>
		<b-overlay :show="loading" no-wrap rounded></b-overlay>
	</div>
</template>

<script>
import api from '../../../../api.js'
import numeral from 'numeral'
import {mapActions} from "vuex";

export default {
	components: {
		// formEditPrice
	},
	props: {
		modelId: {
			type: Number,
			required: true,
		}
	},
	data() {
		return {
			transportServices: [],
			showDetails: false,
			loading: true,
			totalTypes: ["booking"],
			transportServiceId: -1
		}
	},
	computed: {
		fieldsPrices() {
			let fields = [
				{label: this.$t('payments.serviceNumber'), key: "serviceNumber"},
				{label: this.$t('payments.paymentStatus'), key: "paymentStatus"},
				{label: this.$t('payments.totalWithoutTaxes'), key: "lblBookingPriceSubtotal", class: "text-right"},
				{label: this.$t('payments.totalWithTaxes'), key: "lblBookingPriceTotal", class: "text-right"},
			];

			return fields;
		},
		itemsPrices() {
			let items = [];
			this.transportServices.forEach((ts) => {
				let toAdd = {
					lblBookingPriceSubtotal: this.formatLblPrice(ts.bookingPriceSubtotal, ts.bookingCurrency),
					lblBookingPriceTotal: this.formatLblPrice(ts.bookingPriceTotal, ts.bookingCurrency)
				}
				let item = {...ts, ...toAdd}
				items.push(item)
			})
			return items;
		},
		totalsByCurrency() {//sacamos el total por currency
			let info = {booking: {}};

			this.totalTypes.forEach((_type) => {
				this.transportServices.forEach((ts) => {
					let tsCurrency = ts[`${_type}Currency`].toLowerCase();
					if (info[_type][tsCurrency] === undefined) {
						info[_type][tsCurrency] = {//se iniciliza el index
							currency: `${tsCurrency}`,
							subtotal: 0,
							total: 0
						};
					}
					info[_type][tsCurrency].subtotal = info[_type][tsCurrency].subtotal += Number(ts[`${_type}PriceSubtotal`]);
					info[_type][tsCurrency].total = info[_type][tsCurrency].total += Number(ts[`${_type}PriceTotal`]);
				})
			})

			let result = {};
			this.totalTypes.forEach((_type) => {
				result[_type] = Object.values(info[_type]);
			})
			return result;
		},
		totalsBooking() {
			return this.totalsByCurrency.booking;
		}
	},
	methods: {
		...mapActions("reservation", ["_fetchNotes"]),
		fetchModel() {
			this.loading = true
			api(this).get(`/reservations/prices-summary/${this.modelId}`).then(res => {
				this.transportServices = [...res.data]
				this.loading = false
			}).catch(this.$root.handleRequestError);
		},
		formatLblPrice(price, currency) {
			let priceF = numeral(price).format('0,0.[00]');
			return "$" + priceF + " " + (currency.toUpperCase())

		},
	},
	mounted() {
		this.fetchModel()
	}
}
</script>

<style scoped>
.price-input{
	width: 40px;
}

.bg-light-alt {
	background-color: #e9ecef !important;
	color: #6c757d !important;
}

</style>
